/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateTaskInput = {
    project_id?: string;
    title: string;
    description?: string;
    status?: CreateTaskInput.status;
    due_date: string;
    is_key_event?: boolean;
    assignees?: Array<string>;
    reviewers?: Array<string>;
};
export namespace CreateTaskInput {
    export enum status {
        PLANNED = 'planned',
        IN_PROGRESS = 'in-progress',
        REVIEW = 'review',
        DONE = 'done',
    }
}

